// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Paleta de colores Game Boy */
:root {
    --gb-lightest: #e0d8a7;
    --gb-light: #5a7942;
    --gb-dark: #3e6030;
    --gb-darkest: #1a1c1e;
    --gb-accent: #8bac0f;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background-color: var(--gb-lightest);
    color: var(--gb-darkest);
    font-family: 'Press Start 2P', cursive;
    line-height: 1.6;
    font-size: 12px;
}

/* Importar fuente retro */

/* Contenedor principal que ocupa toda la pantalla */
.home-wrapper {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.home {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 30px 0px 30px;
    background-color: var(--gb-light);
    border: 8px solid var(--gb-darkest);
    position: relative;
}

/* Sombra superpuesta que cubre el borde del componente */
.home::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
    pointer-events: none;
    z-index: 10;
}

.home h1 {
    color: var(--gb-lightest);
    text-align: center;
    margin-bottom: 15px;
    margin-top: 0;
    text-shadow: 3px 3px 0 var(--gb-darkest);
    animation: blink 2s infinite;
}

@keyframes blink {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0.8; }
}

.home p {
    color: var(--gb-lightest);
    text-align: center;
    margin-bottom: 25px;
    max-width: 600px;
}

nav ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    margin-bottom: 20px;
}

nav li {
    background-color: var(--gb-darkest);
    border: 4px solid var(--gb-dark);
    padding: 15px 30px;
    transition: all 0.3s;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

nav li:hover {
    background-color: var(--gb-accent);
    border-color: var(--gb-lightest);
    transform: translateY(-5px);
}

nav li:active {
    transform: translateY(-5px) scale(0.95);
}

nav li span {
    color: var(--gb-lightest);
    display: block;
    text-align: center;
}

nav li:hover span {
    color: var(--gb-darkest);
}

/* Estilo especial para el botón de CV */
nav li:last-child {
    background-color: var(--gb-accent);
    border: 4px solid var(--gb-darkest);
    animation: pulse 2s infinite;
}

nav li:last-child span {
    color: var(--gb-darkest);
}

nav li:last-child:hover {
    background-color: var(--gb-lightest);
    border-color: var(--gb-accent);
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

nav li:last-child:hover span {
    color: var(--gb-darkest);
}

@keyframes pulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(139, 172, 15, 0.7);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(139, 172, 15, 0);
    }
}

/* Animación de scroll */
html {
    scroll-behavior: smooth;
}

section {
    scroll-margin-top: 20px;
}

/* Responsive */
@media (max-width: 768px) {
    .home-wrapper {
        padding: 15px;
    }
    
    .home {
        padding: 30px 20px 0px 20px;
    }
    
    .home h1 {
        font-size: 16px;
        margin-bottom: 10px;
    }
    
    .home p {
        margin-bottom: 20px;
    }
    
    nav ul {
        flex-direction: column;
        align-items: center;
        margin-bottom: 15px;
    }
    
    nav li {
        width: 100%;
        max-width: 300px;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/gameboy-theme.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;AACnB;;AAEA,0BAA0B;;AAG1B,oDAAoD;AACpD;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,iCAAiC;IACjC,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,yDAAyD;AACzD;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,oEAAoE;IACpE,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,UAAU,UAAU,EAAE;IACtB,YAAY,YAAY,EAAE;AAC9B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wCAAwC;AACxC;IACI,kCAAkC;IAClC,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,2CAA2C;IAC/C;AACJ;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":["/* Paleta de colores Game Boy */\n:root {\n    --gb-lightest: #e0d8a7;\n    --gb-light: #5a7942;\n    --gb-dark: #3e6030;\n    --gb-darkest: #1a1c1e;\n    --gb-accent: #8bac0f;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    background-color: var(--gb-lightest);\n    color: var(--gb-darkest);\n    font-family: 'Press Start 2P', cursive;\n    line-height: 1.6;\n    font-size: 12px;\n}\n\n/* Importar fuente retro */\n@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');\n\n/* Contenedor principal que ocupa toda la pantalla */\n.home-wrapper {\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.home {\n    width: 100%;\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 40px 30px 0px 30px;\n    background-color: var(--gb-light);\n    border: 8px solid var(--gb-darkest);\n    position: relative;\n}\n\n/* Sombra superpuesta que cubre el borde del componente */\n.home::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 40px;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);\n    pointer-events: none;\n    z-index: 10;\n}\n\n.home h1 {\n    color: var(--gb-lightest);\n    text-align: center;\n    margin-bottom: 15px;\n    margin-top: 0;\n    text-shadow: 3px 3px 0 var(--gb-darkest);\n    animation: blink 2s infinite;\n}\n\n@keyframes blink {\n    0%, 49% { opacity: 1; }\n    50%, 100% { opacity: 0.8; }\n}\n\n.home p {\n    color: var(--gb-lightest);\n    text-align: center;\n    margin-bottom: 25px;\n    max-width: 600px;\n}\n\nnav ul {\n    list-style: none;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 15px;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\nnav li {\n    background-color: var(--gb-darkest);\n    border: 4px solid var(--gb-dark);\n    padding: 15px 30px;\n    transition: all 0.3s;\n    cursor: pointer;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\nnav li:hover {\n    background-color: var(--gb-accent);\n    border-color: var(--gb-lightest);\n    transform: translateY(-5px);\n}\n\nnav li:active {\n    transform: translateY(-5px) scale(0.95);\n}\n\nnav li span {\n    color: var(--gb-lightest);\n    display: block;\n    text-align: center;\n}\n\nnav li:hover span {\n    color: var(--gb-darkest);\n}\n\n/* Estilo especial para el botón de CV */\nnav li:last-child {\n    background-color: var(--gb-accent);\n    border: 4px solid var(--gb-darkest);\n    animation: pulse 2s infinite;\n}\n\nnav li:last-child span {\n    color: var(--gb-darkest);\n}\n\nnav li:last-child:hover {\n    background-color: var(--gb-lightest);\n    border-color: var(--gb-accent);\n    transform: translateY(-5px) scale(1.05);\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);\n}\n\nnav li:last-child:hover span {\n    color: var(--gb-darkest);\n}\n\n@keyframes pulse {\n    0%, 100% {\n        box-shadow: 0 0 0 0 rgba(139, 172, 15, 0.7);\n    }\n    50% {\n        box-shadow: 0 0 0 8px rgba(139, 172, 15, 0);\n    }\n}\n\n/* Animación de scroll */\nhtml {\n    scroll-behavior: smooth;\n}\n\nsection {\n    scroll-margin-top: 20px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .home-wrapper {\n        padding: 15px;\n    }\n    \n    .home {\n        padding: 30px 20px 0px 20px;\n    }\n    \n    .home h1 {\n        font-size: 16px;\n        margin-bottom: 10px;\n    }\n    \n    .home p {\n        margin-bottom: 20px;\n    }\n    \n    nav ul {\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 15px;\n    }\n    \n    nav li {\n        width: 100%;\n        max-width: 300px;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
